import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    profile: undefined,
    model: undefined,
    addresses: [],
    paymentInstruments: [],
    adyenConfig: undefined,
};
export default createSlice({
    name: 'account',
    initialState: initialState,
    reducers: {
        updateAddresses: (state, action) => {
            state.addresses = action.payload;
        },
        updateProfile: (state, action) => {
            state.profile = action.payload;
        },
        updatePaymentInstruments: (state, action) => {
            state.paymentInstruments = action.payload;
        },
        updateAdyenConfig: (state, action) => {
            state.adyenConfig = action.payload;
        },
        updateModel: (state, action) => {
            state.model = action.payload;
        },
    },
});
